// https://shipshapecode.github.io/shepherd/esdoc/

// TODO: edge cases:
// - element is `display:hidden` on mobile: perform a check and move to the next step

import Shepherd from 'shepherd.js';

// filter's panel toggler for mobile

import init from '../base/init';

init(() => {
  if(!window.SHEPHERD_TOURS) return;

  window.SHEPHERD_TOURS.forEach(data => {
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        scrollTo: true,
        showCancelLink: true,
      },
      useModalOverlay: true,
    });

    data.steps.forEach((stepData, i) => {
      const buttons = [];

      if(i > 0) {
        buttons.push({
          action: tour.back,
          classes: 'shepherd-button-secondary',
          text: data.locales.prev,
        });
      }

      buttons.push({
        action: tour.next,
        text: i < data.steps.length - 1 ? data.locales.next : data.locales.finish,
      });

      tour.addStep('example', {
        buttons,
        ...stepData,
      });
    });

    if(data.trigger === 'onload') {
      tour.start();
    }
    else { // selector
      const trigger = document.querySelector(data.trigger);
      if(trigger) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          tour.start();
        });
      }
    }
  });
});

// expand overlay mask opening a bit for a nicer view

// Shepherd.on('show', () => setTimeout(() => {
//   const maskOpening = document.querySelector('rect#shepherdModalMaskOpening');
//   if(!maskOpening) return;
//
//   // alert(maskOpening.getAttribute('x'));
//
//   const x = Math.max(maskOpening.x.baseVal.value - 10, 0);
//   const y = Math.max(maskOpening.y.baseVal.value - 10, 0);
//   const width = maskOpening.width.baseVal.value + 20;
//   const height = maskOpening.height.baseVal.value + 20;
//
//   alert(maskOpening.width.baseVal.value + ' - ' + width);
//
//   maskOpening.setAttribute('x', x);
//   maskOpening.setAttribute('y', y);
//   maskOpening.setAttribute('width', width);
//   maskOpening.setAttribute('height', height);
// }, 500));
